import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/images/icons/Approve_Operator.png';
import _imports_1 from '@/assets/images/icons/decentralized.png';
const _hoisted_1 = {
  class: "mt-3 border-radius-20 dashboard-card",
  style: {
    "overflow": "hidden"
  }
};
const _hoisted_2 = {
  class: "row"
};
const _hoisted_3 = {
  class: "col-md-8 col-12 pt-4 pb-3 order-md-1 order-2",
  style: {
    "padding-left": "40px",
    "padding-right": "40px"
  }
};
const _hoisted_4 = {
  class: "fw-bold fsi-14 mb-2"
};
const _hoisted_5 = {
  class: "fw-medium fsi-14 mb-3",
  style: {
    "color": "rgba(120,122,155,0.8)"
  }
};
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-md-4 col-12 p-2 order-md-2 order-1"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "100%",
    "border-radius": "20px"
  },
  class: "mr-3 d-flex justify-content-center align-items-center align-content-center"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "",
  style: {
    "width": "60%",
    "max-width": "180px"
  }
})])], -1);
const _hoisted_7 = {
  key: 0,
  class: "mt-3 border-radius-20 dashboard-card",
  style: {
    "overflow": "hidden"
  }
};
const _hoisted_8 = {
  class: "row"
};
const _hoisted_9 = {
  class: "col-md-8 col-12 pt-4 pb-3 order-md-1 order-2",
  style: {
    "padding-left": "40px",
    "padding-right": "40px"
  }
};
const _hoisted_10 = {
  class: "fw-bold fsi-14 mb-2"
};
const _hoisted_11 = {
  class: "fw-medium fsi-14 mb-3",
  style: {
    "color": "rgba(120,122,155,0.8)"
  }
};
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-md-4 col-12 p-2 order-md-2 order-1"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "100%",
    "border-radius": "20px"
  },
  class: "mr-3 d-flex justify-content-center align-items-center align-content-center"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {
    "width": "60%",
    "max-width": "180px"
  }
})])], -1);
const _hoisted_13 = {
  key: 1,
  class: "mt-3 border-radius-20 dashboard-card",
  style: {
    "overflow": "hidden"
  }
};
const _hoisted_14 = {
  class: "row"
};
const _hoisted_15 = {
  class: "col-md-8 col-12 pt-4 pb-3 order-md-1 order-2",
  style: {
    "padding-left": "40px",
    "padding-right": "40px"
  }
};
const _hoisted_16 = {
  class: "fw-bold fsi-14 mb-2"
};
const _hoisted_17 = {
  class: "fw-medium fsi-14 mb-3",
  style: {
    "color": "rgba(120,122,155,0.8)"
  }
};
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-md-4 col-12 p-2 order-md-2 order-1"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "100%",
    "border-radius": "20px"
  },
  class: "mr-3 d-flex justify-content-center align-items-center align-content-center"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {
    "width": "60%",
    "max-width": "180px"
  }
})])], -1);
const _hoisted_19 = {
  key: 2,
  class: "mt-3 border-radius-20 dashboard-card",
  style: {
    "overflow": "hidden"
  }
};
const _hoisted_20 = {
  class: "row"
};
const _hoisted_21 = {
  class: "col-md-8 col-12 pt-4 pb-3 order-md-1 order-2",
  style: {
    "padding-left": "40px",
    "padding-right": "40px"
  }
};
const _hoisted_22 = {
  class: "fw-bold fsi-14 mb-2"
};
const _hoisted_23 = {
  class: "fw-medium fsi-14 mb-3",
  style: {
    "color": "rgba(120,122,155,0.8)"
  }
};
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", {
  class: "col-md-4 col-12 p-2 order-md-2 order-1"
}, [/*#__PURE__*/_createElementVNode("div", {
  style: {
    "height": "100%",
    "border-radius": "20px"
  },
  class: "mr-3 d-flex justify-content-center align-items-center align-content-center"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {
    "width": "60%",
    "max-width": "180px"
  }
})])], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('farm.console.ApproveOperator')), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('farm.console.ApproveOperatorTip')), 1), _createElementVNode("div", {
    style: {
      "display": "inline-block",
      "padding": "8px 20px",
      "border-radius": "20px"
    },
    class: "fw-medium fs-12 cursor-pointer mb-1 learn-more",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.setOperator && $options.setOperator(...args))
  }, _toDisplayString(_ctx.$t('farm.console.ApproveOperatorBtn')), 1)]), _hoisted_6])]), !$options.nodeDataLoading && parseInt($options.currentNode.role) === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('subpool.Beneficiary upgrading owner delegation')), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('subpool.Change node delegation role and increase leverage')), 1), _createElementVNode("div", {
    style: {
      "display": "inline-block",
      "padding": "8px 20px",
      "border-radius": "20px"
    },
    class: "fw-medium fs-12 cursor-pointer mb-1 learn-more",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.beneficiaryToOwnerUpgrade && $options.beneficiaryToOwnerUpgrade(...args))
  }, _toDisplayString(_ctx.$t('subpool.Convert now')), 1)]), _hoisted_12])])) : _createCommentVNode("", true), !$options.paused && !$options.nodeDataLoading && parseInt($options.currentNode.role) === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('subpool.Migrate to the contract pool')), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('subpool.Migrate to the contract pool')), 1), _createElementVNode("div", {
    style: {
      "display": "inline-block",
      "padding": "8px 20px",
      "border-radius": "20px"
    },
    class: "fw-medium fs-12 cursor-pointer mb-1 learn-more",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.migratorToLendingPool && $options.migratorToLendingPool(...args))
  }, _toDisplayString(_ctx.$t('subpool.Migration now')), 1)]), _hoisted_18])])) : _createCommentVNode("", true), !$options.nodeDataLoading ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('farm.console.Unrestricted')), 1), _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('farm.console.UnrestrictedTip')), 1), _createElementVNode("div", {
    style: {
      "display": "inline-block",
      "padding": "8px 20px",
      "border-radius": "20px"
    },
    class: "fw-medium fs-12 cursor-pointer mb-1 learn-more",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.offboarding && $options.offboarding(...args))
  }, _toDisplayString(_ctx.$t('farm.console.UnrestrictedBtn')), 1)]), _hoisted_24])])) : _createCommentVNode("", true)]);
}